<template>
  <div
    class="block page1"
    :style="{ backgroundImage: `url(${moduleData?.background_img || DEFAULT_BG})` }"
    id="page1"
  >
    <div class="page1-top f-r">
      <div class="desc">
        <img
          v-if="moduleData.isUpload && !!moduleData.exclusive_logo"
          :src="moduleData.exclusive_logo"
          alt=""
        >
        <div class="title">{{ moduleData.report_name }}</div>
        <div class="title2">{{ moduleData.report_name_en }}</div>
        <div class="title3">{{moduleData.date}}</div>
      </div>
    </div>
    <div class="page1-bottom f-r a-c">
      <!--      <div v-if="moduleData.is_polygon" class="round f-s">调研面积：{{ moduleData.area_size }}k㎡</div>-->
      <div class="round f-s">{{ PAGE_TEXT[commonLang].info1 }}：{{ getText }}</div>
      <div class="address">{{ PAGE_TEXT[commonLang].info2 }}：{{ moduleData.address }}</div>
    </div>
  </div>
</template>

<script setup>
import DEFAULT_BG from '@/assets/bg-front.png'
import { computed } from "vue";

const props = defineProps({
  moduleData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  commonLang: {
    type: String,
  },
});

const PAGE_TEXT = {
  'zh': {
    info1: '调研范围',
    info2: '地址',
    timeUnit: '分钟',
    radius: '半径',
    dsqType1: '步行',
    dsqType2: '车行',
    dsqType3: '自定义范围',
  },
  'en': {
    info1: 'Survey Range',
    info2: 'Address',
    timeUnit: 'minute',
    radius: 'radius',
    dsqType1: 'walk',
    dsqType2: 'car',
    dsqType3: 'customized',
  }
}

const getText = computed(() => {
  let text = '--'
  if (props?.moduleData?.dsq_type === 1) {
    text = `${PAGE_TEXT[props.commonLang].dsqType1}${props?.moduleData?.dsq_range || '--'}${PAGE_TEXT[props.commonLang].timeUnit}`
  } else if (props?.moduleData?.dsq_type === 3) {
    text = `${PAGE_TEXT[props.commonLang].dsqType2}${props?.moduleData?.dsq_range || '--'}${PAGE_TEXT[props.commonLang].timeUnit}`
  } else if ([4,5].includes(props?.moduleData?.dsq_type)) {
    text = PAGE_TEXT[props.commonLang].dsqType3
  } else {
    text = `${PAGE_TEXT[props.commonLang].radius}${props?.moduleData?.radius || '--'}km`
  }
  return text
})
</script>

<style lang="less" scoped>
.report-page {

  .page1 {
    display: flex;
    flex-direction: column;
    //background-image: url("~@/assets/bg.png");
    background-size: 100% 1080px;
    background-repeat: no-repeat;

    .page1-top {
      flex: 1;
      display: flex;
      align-items: center;

      .desc {
        padding-top: 80px;
        padding-left: 202px;
        width: 100%;

        img {
          margin-top: -137px;
          width: auto;
          height: 137px;
        }

        .title {
          max-width: 80%;
          min-height: 118px;
          line-height: 118px;
          font-size: 84px;
          font-weight: 600;
          color: #333333;
        }
        .title2 {
          height: 67px;
          font-size: 48px;

          font-weight: bold;
          color: #333333;
          line-height: 67px;
          margin-top: 4px;
        }
        .title3 {
          height: 67px;
          font-size: 48px;
          font-weight: 400;
          color: #333333;
          line-height: 67px;
          margin-top: 23px;
        }
      }
    }

    .page1-bottom {
      width: 100%;
      min-height: 118px;
      background: rgba(51, 51, 51, 0.39);
      padding: 0 60px;
      font-size: 36px;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;
      .round {
        flex-shrink: 0;
        margin-right: 136px;
      }
    }
  }
}
</style>
